import { RequestInitLike } from '@prismicio/client';

export const productionCache: RequestInitLike = {
  next: { tags: ['prismic'] },
  cache: 'force-cache',
};

export const developmentCache: RequestInitLike = { next: { revalidate: 5 } };
